module.exports = __webpack_public_path__ + "img/bot-desc.d4f249c9.png";